package game.entity

import com.soywiz.korma.geom.PointInt
import game.*
import kotlin.random.Random

class InvisibleWall(col: Int, row: Int) : Entity(col = col, row = row) {
    override fun onCollideWithPlayer(game: Game, room: Room): Boolean {
        return false
    }
}

class Laser : Enemy(1, 1) {
    override val deathSound: String? = null

    var speed = 7

    var step = 0
    var coolDown = 0
    var flash = false

    override fun onInit(game: Game, room: Room) {
        sprite = game.getSpriteById("laser")
    }

    override fun onTick(game: Game, room: Room) {
        coolDown--

        if (coolDown <= 0) {
            val entity = room.getEntityAt(col, row + 1)

            if (entity is Barrier) {
                row++
                killMe(game)
                room.removeEntity(entity)
            }
            if (room[col, row + 1].type == TileType.Floor) {
                row++
            } else {
                room.removeEntity(this)
            }
            coolDown = speed
        }
    }

    override fun onCollideWithPlayer(game: Game, room: Room): Boolean {
        killMe(game)

        return super.onCollideWithPlayer(game, room)
    }
}

class SpikeBall : Enemy(1, 1) {
    override val deathSound: String? = null

    var speed = 7

    var step = 0
    var coolDown = 0
    var flash = false

    override fun onInit(game: Game, room: Room) {
        sprite = game.getSpriteById("spike-ball")
    }

    override fun onTick(game: Game, room: Room) {
        coolDown--

        if (coolDown <= 0) {
            when (step) {
                0 -> {
                    val entity = room.getEntityAt(col, row + 1)

                    if (entity is Barrier) {
                        row++
                        killMe(game)
                        room.removeEntity(entity)
                    }
                    if (room[col, row + 1].type == TileType.Floor) {
                        row++
                    } else {
                        step++
                    }
                    coolDown = speed
                }
                1 -> {
                    if (row > 16) {
                        row--
                    } else {
                        step++
                    }

                    coolDown = speed
                }
                2 -> {
                    coolDown = speed * 50
                    step++
                }
                3 -> {
                    flash = true
                    coolDown = speed * 20
                    step++
                }
                4 -> {
                    room.removeEntity(this)
                }
                10 -> {
                    row--

                    val entity = room.getEntityAt(col, row)

                    if (entity is Invader) {
                        entity.takeDamage(game, 1)
                    }

                    if (room[col, row].type != TileType.Floor) {
                        row++
                        killMe(game)
                    }

                    if (row == 0) {
                        room.removeEntity(this)
                    }

                    coolDown = speed
                }
            }
        }

        sprite = if (flash && (coolDown / 5 % 2) == 0) {
            null
        } else {
            game.getSpriteById("spike-ball")
        }
    }

    override fun onCollideWithPlayer(game: Game, room: Room): Boolean {
        killMe(game)

        return super.onCollideWithPlayer(game, room)
    }

    override fun onAttacked(game: Game, weapon: Weapon) {
        step = 10
        coolDown = 0
        flash = false
        sprite = game.getSpriteById("spike-ball")
    }
}

class Barrier(col: Int, row: Int) : Entity(col = col, row = row) {
    override fun onInit(game: Game, room: Room) {
        sprite = game.getSpriteById("barrier")
    }
}

class Invader : Enemy(10, 5) {
    val minCol = 4
    val maxCol = 40
    val moveSpeed = 0
    val attackSpeed = 17

    var direction = 1
    var moveCoolDown = moveSpeed
    var attackCoolDown = attackSpeed

    override fun onInit(game: Game, room: Room) {
        sprite = game.getSpriteById("invader")
        width = 5
        height = 3
    }

    override fun onTick(game: Game, room: Room) {
        moveCoolDown--

        if (moveCoolDown <= 0) {
            col += direction
            if (col !in minCol..maxCol) {
                direction *= -1
            }

            moveCoolDown = moveSpeed + hp
        }

        attackCoolDown--

        if (attackCoolDown <= 0) {
            val attack = if (Random.nextInt(5) == 0) {
                SpikeBall()

            } else {
                Laser()
            }.also {
                it.col = col + 2
                it.row = row + 2
            }
            room.addEntity(attack)

            game.playSound("invader")
            attackCoolDown = hp + Random.nextInt(attackSpeed) + 2
        }
    }
}

class CobblerBattle : Entity() {
    var step = 0
    var coolDown = 0
    var door1 = Door().apply { col = 36 }
    var door2 = Door().apply { col = 15 }
    var battleEntities = mutableListOf<Entity>()

    override fun onTick(game: Game, room: Room) {
        when (step) {
            0 -> {
                if (game.player.row >= 3) {
                    room.addEntity(door1)
                    room.addEntity(door2)
                    game.playSound("door-close")
                    step++
                }
            }
            1 -> {
                if (game.player.row >= 17) {
                    createBarrier(5, 12)
                    createBarrier(20, 12)
                    createBarrier(35, 12)

                    battleEntities.forEach { room.addEntity(it) }

                    val invader = Invader().apply {
                        col = 4
                        row = 4
                    }
                    invader.onDeath = {
                        step++
                    }

                    room.addEntity(invader)

                    game.playSound("door-close")

                    step++
                }
            }
            2 -> {
                // Battle
            }
            3 -> {
                battleEntities.forEach { room.removeEntity(it) }
                room.removeEntity(door1)
                room.removeEntity(door2)
                game.playSound("door-open")
                room.removePermanently(game, this)
            }
        }
    }

    private fun createBarrier(col: Int, row: Int) {
        val positions = arrayOf(
            PointInt(1, 0),
            PointInt(2, 0),
            PointInt(3, 0),
            PointInt(4, 0),
            PointInt(5, 0),
            PointInt(6, 0),

            PointInt(0, 1),
            PointInt(1, 1),
            PointInt(2, 1),
            PointInt(3, 1),
            PointInt(4, 1),
            PointInt(5, 1),
            PointInt(6, 1),
            PointInt(7, 1),

            PointInt(0, 2),
            PointInt(1, 2),
            PointInt(2, 2),
            PointInt(3, 2),
            PointInt(4, 2),
            PointInt(5, 2),
            PointInt(6, 2),
            PointInt(7, 2),

            PointInt(0, 3),
            PointInt(1, 3),
            PointInt(6, 3),
            PointInt(7, 3),
        )

        positions.forEach { battleEntities.add(Barrier(it.x + col, it.y + row)) }

        for (wallCol in 0 until ROOM_WIDTH) {
            battleEntities.add(InvisibleWall(wallCol, 16))
            battleEntities.add(InvisibleWall(wallCol, 18))
        }
    }
}